import React, { FC } from 'react'
import styled from 'styled-components'
import Stack from '@mui/material/Stack';
import Slider from '@mui/material/Slider';
import VolumeDown from '@mui/icons-material/VolumeDown';
import VolumeUp from '@mui/icons-material/VolumeUp';

interface Props2 {
    openMenu: boolean
}
interface Props{
    volume: number
    setVolume: React.Dispatch<React.SetStateAction<number>>
    spin: boolean
}
type MultiProps = Props & Props2

export const Settings: FC<MultiProps> = ({volume, setVolume, spin, openMenu}) => {
    const handleChange = (event: Event, newValue: number | number[]) => {
        setVolume(newValue as number);
        localStorage.setItem("volume", JSON.stringify(volume))
      };
      function valuetext(value: number) {
        return `${value}`;
      }
    
    return (
        <Container openMenu={openMenu}>
            <Span>Volume</Span>
            <Stack spacing={2} direction="row" sx={{ mb: 1 }} alignItems="center">
                <VolumeDown />
                <Slider aria-label="Volume" 
                    value={volume} 
                    onChange={handleChange} 
                    disabled={spin}
                    min={0}    
                    max={1}
                    step={0.05}
                    getAriaValueText={valuetext}
                />
                <VolumeUp />
            </Stack>
        </Container>
    )
}

const Container = styled.div<Props2>`
    position: absolute;
    top: 0;
    right: 0;
    background-color: #ffffffc8;
    width: 200px;
    max-width: 50vw;
    padding: 0.3rem 1rem;
    z-index: 3;
    transition: transform .2s linear;
    transform: translateX(${({openMenu}) => (openMenu ? 0 : 200)}px);
`
const Span = styled.span`
    font-size: 0.8rem;
    margin-left: 1rem;
`